<template>
	<transition
			name="custom-classes-transition"
			:enter-active-class="$_pl_styleComponentAnimation()">
		<template v-if="$_pl_stateComponentIsInitialized">
			<v-progress-linear 
					:buffer-value="$_pl_styleProgressLinearBufferValue"
					:color="$_pl_styleProgressLinearColor"
					:indeterminate="$_pl_styleProgressLinearIndeterminate"
					:value="$_pl_styleProgressLinearValue" />
		</template>
		<template v-else>
			<v-progress-linear indeterminate />
		</template>
	</transition>
</template>

<script>
	export default {
		name: 'ProgressLinear',
		data() {
			return {
				componentName_: 'progressLinear'
			}
		},
		computed: {
			// state
			$_pl_stateComponentIsInitialized() {
				const self_ = this;
				return self_.getComponentState('isInitialized')
			},
			// contents / inits
			$_pl_contents() {
				const self_ = this;
				return () => {
					const contents_ = self_.getComponentContents(self_.componentName_)
					return self_.getContentsSubset(contents_, 'isDummy', false)
				}
			},
			$_pl_inits() {
				const self_ = this;
				return () => {
					return self_.getComponentInits(self_.componentName_)
				}
			},
			// style
			$_pl_styleComponent() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.$_pl_inits())) { return null }
					return self_.getInitsStyleVal(self_.$_pl_inits(), 'component')
				}
			},
			$_pl_styleComponentAnimation() {
				const self_ = this;
				return () => {
					const component_ = self_.$_pl_styleComponent()
					if(self_.isFalse(component_)) { return null }
					return self_.getStylesVal(component_.animation)
				}
			},
			$_pl_styleProgressLinear() {
				const self_ = this;
				if(self_.isEmpty(self_.$_pl_inits())) { return null }
				return self_.getInitsStyleVal(self_.$_pl_inits(), 'progressLinear')
			},
			$_pl_styleProgressLinearBufferValue() {
				const self_ = this;
				const progress_ = self_.$_pl_styleProgressLinear;
				if(self_.isFalse(progress_)) { return null }
				return self_.getStylesVal(progress_.bufferValue)
			},
			$_pl_styleProgressLinearColor() {
				const self_ = this;
				const progress_ = self_.$_pl_styleProgressLinear;
				if(self_.isFalse(progress_)) { return null }
				return self_.getStylesVal(progress_.color)
			},
			$_pl_styleProgressLinearIndeterminate() {
				const self_ = this;
				const progress_ = self_.$_pl_styleProgressLinear;
				if(self_.isFalse(progress_)) { return null }
				return self_.getStylesVal(progress_.indeterminate)
			},
			$_pl_styleProgressLinearSize() {
				const self_ = this;
				const progress_ = self_.$_pl_styleProgressLinear;
				if(self_.isFalse(progress_)) { return null }
				return self_.getStylesVal(progress_.size)
			},
			$_pl_styleProgressLinearValue() {
				const self_ = this;
				const progress_ = self_.$_pl_styleProgressLinear;
				if(self_.isFalse(progress_)) { return null }
				return self_.getStylesVal(progress_.value)
			},
			$_pl_styleProgressLinearWidth() {
				const self_ = this;
				const progress_ = self_.$_pl_styleProgressLinear;
				if(self_.isFalse(progress_)) { return null }
				return self_.getStylesVal(progress_.width)
			}
		}
	}
</script>